<div class="row">
    <div class="col-lg-12">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-buttons
                        [grid]="grid"
                        [canEdit]="canEdit"
                        [showAdd]="true"
                        [showEdit]="true"
                        [showDelete]="true"
                    ></action-toolbar-buttons>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    #mainGrid
                    appAutoSize
                    [minHeight]="200"
                    (initialized)="grid.initialize(mainGrid); onGridInitialized()"
                    (destroy)="grid.destroy()"
                    [itemsSource]="grid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column
                        [header]="'Sacrificial Anode Bag Size'"
                        [binding]="'sacrificialAnodeBagSize'"
                        [width]="180"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Installation Location'"
                        [binding]="'installationLocation'"
                        [width]="160"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Number of Anode Bags'"
                        [binding]="'numberOfAnodeBags'"
                        [width]="170"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Test Station Type and Location'"
                        [binding]="'testStationTypeAndLocation'"
                        [width]="220"
                    ></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>
</div>
